var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"white-row row"},[_c('div',{staticClass:"white-row-body col-12"},[_vm._t("default",[_vm._v("white row")])],2)])}
var staticRenderFns = []

export { render, staticRenderFns }